
import mode from "@/mode.js";
const app = {
    name: 'GROWER',
    company: 'Trees 4 Trees',
    guide: null,
    logo: {
      sm: './static/img/logo/720x720.svg',
      md: './static/img/logo/480x480.svg',
      lg: './static/img/logo/240x240.svg'
    },
    microservices: {
      gisPolygons:
        mode === 'stagging'
          ? 'https://grower-polygons-handler.trees4trees.org'
          : 'http://localhost:4000'
    },
    server: {
      development: 'http://localhost:8000/api',
      demo: 'http://127.0.0.1:8000',
      stagging: 'https://grower-staging.trees4trees.org/api',
      production: 'https://grower-staging.trees4trees.org/api',
    },
    download: {
      android: 'https://play.google.com/store/',
      ios: 'https://www.apple.com/id/app-store/'
    },
    options: {
      allowRegister: false,
      forgetPassword: true,
      autofill: false,
      myAction: false,
      mobileView: true,
      yearOptions: ['2020', '2021', '2022', '2023', '2024', '2025'],
      yearDefault: '2025'
    },
    apikey: {
      gmap: 'AIzaSyArJkzKNSGOGAwtMcsCl6cRlFfAG_dIqmE',
      mapbox: 'pk.eyJ1Ijoiam9oYW5yb2VkIiwiYSI6ImJVYmoyTUEifQ.1xKUxaVIFEmtC7IusBQ88g'
    },
    appkey: 'rbsmixsolution-2022'
  
  }
  
  // =========================================================
  // File CUSTOM Variable SCSS
  // static\assets\sass\components\_variables.demo.scss
  // super Admin ACC 
  // admin@trees4trees.org
  // telagabodas43-1
  // =========================================================
  
  export default app
  


// WEBPACK FOOTER //
// ./src/config.js